import React, { ReactNode } from 'react'

import { PageContent, PageShell } from './styles'

interface PageContainerProps {
  children: ReactNode
  className?: string
}

const PageContainer = ({ children, className }: PageContainerProps) => (
  <PageShell className={className}>
    <PageContent>{children}</PageContent>
  </PageShell>
)

export default PageContainer
